import { render, staticRenderFns } from "./MarketingFleetPage.vue?vue&type=template&id=ef05bdac"
import script from "./MarketingFleetPage.vue?vue&type=script&lang=js"
export * from "./MarketingFleetPage.vue?vue&type=script&lang=js"
import style0 from "./MarketingFleetPage.vue?vue&type=style&index=0&id=ef05bdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports